
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CLAccount } from './account';
import { Apollo } from 'apollo-angular';
import { map as _map } from 'lodash';

const AccountsQuery = require('./gql/accounts.query.gql');
const AccountQuery = require('./gql/account.query.gql');

const createCLAccountMutation = require('./gql/create-account.mutation.gql');
const updateCLAccountMutation = require('./gql/update-account.mutation.gql');
const deleteCLAccountMutation = require('./gql/delete-account.mutation.gql');
const restoreCLAccountMutation = require('./gql/restore-account.mutation.gql');

export interface CLAccountsQueryResult {
  accounts: CLAccount[]
  accountsCount: number
}

export type CLAccountOrderBy = 'NAME' | 'CREATED_AT';
export type CLAccountOrderByDirection = 'ASC' | 'DESC';

export class CLAccountFilter {
  offset: number
  limit: number

  search = '';
  orderBy: CLAccountOrderBy = 'NAME';
  orderDir: CLAccountOrderByDirection = 'ASC';
  deleted: boolean = false;
}


@Injectable()
export class CLAccountService {

  constructor(private apollo: Apollo) { }

  accounts(filter: CLAccountFilter): Observable<CLAccountsQueryResult> {
    return this.apollo
      .query({
        query: AccountsQuery,
        variables: {
          filter
        },
        fetchPolicy: 'no-cache'
      }).pipe(
      map((result) => {
        let items = result.data['clAccounts']['items'];
        let total = result.data['clAccounts']['total'];

        items = _map(items, item => new CLAccount(item));

        return {
          accounts: items,
          accountsCount: total,
        };
      }));
  }

  account(id: string): Observable<CLAccount> {
    return this.apollo
      .query({
        query: AccountQuery,
        variables: {
          id
        },
        fetchPolicy: 'no-cache'
      }).pipe(
      map(result => result.data['clAccount'] ? new CLAccount(result.data['clAccount']) : null));
  }

  create(account: CLAccount): Observable<CLAccount> {
    return this.apollo
      .mutate({
        mutation: createCLAccountMutation,
        variables: {
          input: account.toCreateCLAccountInput()
        }
      }).pipe(
      map(result => new CLAccount(result.data['createCLAccount'])));
  }

  update(id: string, account: CLAccount): Observable<CLAccount> {
    return this.apollo
      .mutate({
        mutation: updateCLAccountMutation,
        variables: {
          id,
          input: account.toUpdateCLAccountInput()
        }
      }).pipe(
      map(result => new CLAccount(result.data['updateCLAccount'])));
  }

  delete(id: string): Observable<CLAccount> {
    return this.apollo
      .mutate({
        mutation: deleteCLAccountMutation,
        variables: {
          id
        }
      }).pipe(
      map(result => new CLAccount(result.data['deleteCLAccount'])));
  }

  restore(id: string): Observable<CLAccount> {
    return this.apollo
      .mutate({
        mutation: restoreCLAccountMutation,
        variables: {
          id
        }
      }).pipe(
      map(result => new CLAccount(result.data['restoreCLAccount'])));
  }
}
